import React, { useEffect, useRef, useState } from "react";
import { SwiperArrowBtn } from "./SwiperArrowBtn";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

export const SliderWithArrowsScroll = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [isScrolledToStart, setIsScrolledToStart] = useState(true);
  const [isScrolledToEnd, setIsScrolledToEnd] = useState(false);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -200,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 200,
        behavior: "smooth",
      });
    }
  };

  const checkScrollPosition = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } =
        scrollContainerRef?.current;
      setIsScrolledToStart(scrollLeft === 0);
      setIsScrolledToEnd(scrollLeft + clientWidth >= scrollWidth - 20);
    }
  };

  useEffect(() => {
    if (scrollContainerRef.current) {
      checkScrollPosition();
      const handleScroll = () => {
        checkScrollPosition();
      };
      const currentRef = scrollContainerRef.current;

      if (currentRef) {
        currentRef.addEventListener("scroll", handleScroll);
      }

      return () => {
        if (currentRef) currentRef.removeEventListener("scroll", handleScroll);
      };
    }
  }, [scrollContainerRef, children]);

  return (
    <div className="flex relative">
      {!isScrolledToStart && (
        <SwiperArrowBtn
          disabled={isScrolledToStart}
          Icon={ChevronLeft}
          action={scrollLeft}
          className="absolute top-0 left-0 z-[1] invisible md:visible"
        />
      )}
      <div
        ref={scrollContainerRef}
        className="flex-1 flex items-center overflow-x-scroll overflow-auto space-x-[8px] scrollbar-hide"
      >
        {children}
      </div>
      {!isScrolledToEnd && (
        <SwiperArrowBtn
          disabled={isScrolledToEnd}
          Icon={ChevronRight}
          action={scrollRight}
          className="absolute top-0 right-0 z-[1] invisible md:visible"
        />
      )}
    </div>
  );
};
